var map = {
	"./5-Albedo.webp": 4540,
	"./5-Ayaka.webp": 2246,
	"./5-Diluc.webp": 9569,
	"./5-Ganyu.webp": 4257,
	"./5-Hutao.webp": 8851,
	"./5-Jean.webp": 8706,
	"./5-Kazuha.webp": 5188,
	"./5-Keqing.webp": 5739,
	"./5-Klee.webp": 736,
	"./5-Kokomi.webp": 4674,
	"./5-Mona.webp": 1986,
	"./5-Qiqi.webp": 8786,
	"./5-Shogun.webp": 8564,
	"./5-Tartaglia.webp": 2605,
	"./5-Venti.webp": 5567,
	"./5-Xiao.webp": 4601,
	"./5-Yoimiya.webp": 2256,
	"./5-Zhongli.webp": 8010,
	"./5-joker.webp": 1914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6814;